import { useState } from "react";
import CreateTextField from "./CreateTextField";

export type EditableTextProps = {
	value: string;
	editable?: boolean;

	onChange: (value: string) => void;
};

const EditableText: React.FC<EditableTextProps> = (
	props: EditableTextProps
) => {
	const [edit, setEdit] = useState(false);

	function updateValue(value: string): void {
		if (value !== props.value) {
			props.onChange(value);
		}

		setEdit(false);
	}

	return edit ? (
		<CreateTextField
			variant="standard"
			fullWidth
			autoFocus={true}
			value={props.value}
			onCreate={updateValue}
		/>
	) : (
		<div
			style={(props.editable ?? true) ? { cursor: "pointer" } : {}}
			onClick={() => (props.editable ?? true) && setEdit(true)}>
			{props.value}
		</div>
	);
};

export default EditableText;
